import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getEntitlements } from "./api";
import { useAuth } from "./auth";

const Ctx = createContext(null);

const DEFAULTS = {
  is_pro: false,
  comp: false,
  status: null, // trialing | active | past_due | canceled | comp | null
  plan: null, // pro_monthly | pro_annual
  trial_end: null,
  current_period_end: null,
  cancel_at_period_end: false,
};

export function EntitlementsProvider({ children }) {
  const { status } = useAuth();
  const [data, setData] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const e = await getEntitlements();
      setData({ ...DEFAULTS, ...e });
    } catch {
      // keep previous
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (status === "loading") return;
    // Auth just settled (e.g. right after login) — mark not-loaded so route guards
    // wait for the FRESH entitlement instead of acting on the stale anonymous value.
    setLoaded(false);
    refresh();
  }, [status, refresh]);

  const value = useMemo(() => ({ ...data, loaded, refresh }), [data, loaded, refresh]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useEntitlements() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useEntitlements must be used within EntitlementsProvider");
  return ctx;
}
